import axios from 'axios';
import {Toast} from "vant"
import errorCodes from "@/api/errorCodes"

axios.interceptors.request.use(config => {
    if(sessionStorage.getItem("token")) {
      config.headers["Authorization"] = sessionStorage.getItem("token");
    }
    return config;
  },
  error => Promise.reject(error)
);

axios.interceptors.response.use(res => {
    return res;
  },
  error => {
    let errCode = error.response.data.error?.code;
    if (errCode) {
      Toast(errorCodes[errCode]);
    }

    // 错误码判断
    return Promise.reject(error);
  }
);